"use strict";

var bannerFlowUser;
var _sqh = _sqh || [];

var _BannerFlowApp = angular
    .module("BannerFlowApp", [
        "bfConstants",
        "cacheBuster",
        "pasvaz.bindonce",
        "angularMoment",
        "http-auth-interceptor",
        "toggle-switch",
        "ngRoute",
        "ngSanitize",
        "ui.router",
        "ngResource",
        "tableSort",
        "ui",
        "ui.bootstrap.tooltip",
        "bsSelectModule",
        "RecursionHelper",
        "bf.sortable",
        "ui.slider",
        "ui.bootstrap.datetimepicker",
        "ui.calendar",
        "color.picker",
        "ngDialog",
        "ngTable",
        "angularUtils.directives.dirPagination",
        "infinite-scroll",
        "sticky",
        "monospaced.elastic",
        "ui-bootstrap-paging"
    ])
    .config([
        "$stateProvider",
        "$urlRouterProvider",
        "$sceDelegateProvider",
        "$sceProvider",
        "$locationProvider",
        function (
            $stateProvider,
            $urlRouterProvider,
            $sceDelegateProvider,
            $sceProvider,
            $locationProvider
        ) {
            $urlRouterProvider.rule(function ($injector, $location) {
                var path = $location.path(),
                    search = $location.search(),
                    params;

                if (path[path.length - 1] === "/" && path != "//") {
                    path = path.substring(0, path.length - 1);
                } else {
                    return;
                }

                return path;
            });

            $urlRouterProvider.otherwise(function ($injector, $location) {
                let path = $location.path();
                if (path.startsWith("/")) {
                    path = path.slice(1);
                }

                const pathSegments = path.split("/");

                // Undefined behaviour, go to BFC error
                if (pathSegments.length < 2) {
                    indow.open("/v2/error", "_self");
                } else {
                    window.open("/v2/{0}/{1}/404".format(pathSegments[0], pathSegments[1]), "_self");
                }

                return;
            });

            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false
            });

            $sceProvider.enabled(false);

            var url_prefix = ":rootAccountId/:rootBrandId";

            $stateProvider
                .state("o", {
                    url: "/:rootAccountId?",
                    controller: "RootController"
                })
                .state("root", {
                    url: "/" + url_prefix,
                    templateUrl: "/legacy-app/views/root.html",
                    controller: "MainController"
                })
                //Landing pages
                .state("root.landingpages", {
                    title: "Landing pages",
                    url: "/LandingPages?includeArchived&users&labels&query&page&sorto&sortf&count&showLabels",
                    reloadOnSearch: false,
                    params: {
                        includeArchived: { squash: true, value: null },
                        users: { squash: true, value: null },
                        labels: { squash: true, value: null },
                        query: { squash: true, value: null },
                        page: { squash: true, value: null },
                        count: { squash: true, value: null },
                        sortf: { squash: true, value: null },
                        sorto: { squash: true, value: null },
                        showLabels: { squash: true, value: null }
                    },
                    views: {
                        "main-view@root": {
                            templateUrl: "/legacy-app/views/Create/LandingPages/landingpages.html",
                            controller: "LandingPagesController"
                        }
                    }
                })
                .state("root.landingpages.folder", {
                    title: "Landing pages",
                    url: "/f/{folderId:[A-Za-z0-9\-]{1,128}}",
                    reloadOnSearch: false,
                    views: {
                        "main-view@root": {
                            templateUrl: "/legacy-app/views/Create/LandingPages/landingpages.html",
                            controller: "LandingPagesController"
                        }
                    }
                })
                .state("root.feeds", {
                    title: "Feeds",
                    url: "/Feeds?includeArchived&users&labels&query&page&sorto&sortf&count&showLabels",
                    reloadOnSearch: false,
                    params: {
                        includeArchived: { squash: true, value: null },
                        users: { squash: true, value: null },
                        labels: { squash: true, value: null },
                        query: { squash: true, value: null },
                        page: { squash: true, value: null },
                        count: { squash: true, value: null },
                        sortf: { squash: true, value: null },
                        sorto: { squash: true, value: null },
                        showLabels: { squash: true, value: null }
                    },
                    views: {
                        "main-view@root": {
                            templateUrl: "/legacy-app/views/Create/Feeds/feeds.html",
                            controller: "FeedsController"
                        }
                    }
                })
                .state("root.feeds.folder", {
                    title: "Feeds",
                    url: "/f/{folderId:[A-Za-z0-9\-]{1,128}}",
                    reloadOnSearch: false,
                    views: {
                        "main-view@root": {
                            templateUrl: "/legacy-app/views/Create/Feeds/feeds.html",
                            controller: "FeedsController"
                        }
                    }
                })
                .state("root.feeds.feed", {
                    title: "Create",
                    url: "/c/{feedId:[A-Za-z0-9\-]{1,128}}?id",
                    params: {
                        id: { squash: true, value: null }
                    },
                    views: {
                        "main-view@root": {
                            templateUrl: "/legacy-app/views/Create/Feeds/feed.html",
                            controller: "FeedController"
                        }
                    }
                });
        }
    ])
    .run([
        "$rootScope",
        "$state",
        "$stateParams",
        "authService",
        "$timeout",
        "$location",
        "$window",
        "Global",
        "AuthInfo",
        "EventManager",
        "Utils",
        "Page",
        "History",
        "Cookie",
        "Setting",
        function (
            $rootScope,
            $state,
            $stateParams,
            authService,
            $timeout,
            $location,
            $window,
            Global,
            AuthInfo,
            EventManager,
            Utils,
            Page,
            History,
            Cookie,
            Setting
        ) {
            if (!bannerFlowUser) {
                return;
            }

            $rootScope.bannerFlowUser = bannerFlowUser;

            AuthInfo.Init(bannerFlowUser, false);

            $rootScope.AuthInfo = AuthInfo;
            $rootScope.Global = Global;
            $rootScope.Utils = Utils;
            $rootScope.History = History;
            $rootScope.Page = Page;
            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;
            $rootScope.isLoaded = false;
            $rootScope.loggedIn = true;
            $rootScope.modalOpen = false;
            $rootScope.isBrowserAllowed = false;
            $rootScope.isAdBlockerInstalled = false;
            $rootScope.newPublishedBanners = false;
            $rootScope.showNoPermissionDialog = false;
            $rootScope.showNoFeatureDialog = false;
            $rootScope.saved = false;
            $rootScope.isMenuExpanded = false;

            $.fn.editable.defaults.mode = "popup";
            $.fn.editableform.buttons =
                '<button type="submit" style="width: 60px;padding: 4px;" class="pull-right btn btn-primary editable-submit">Done</button>';

            if (window.File && window.FileList && window.FileReader) {
                $rootScope.isBrowserAllowed = true;
            } else {
                $rootScope.isBrowserAllowed = false;
            }

            $rootScope.USER_ROLE_NONE = 0;
            $rootScope.USER_ROLE_USER = 1;
            $rootScope.USER_ROLE_ADMIN = 2;
            $rootScope.USER_ROLE_OWNER = 3;

            $rootScope.cache = {};

            EventManager.SetupEventHandlers();

            $rootScope.tryAgain = function () {
                window.location = "/";
            };

            $(document).ready(function () {
                var x = document.getElementById("adpbtest");
                if (!x) {
                    $rootScope.isAdBlockerInstalled = false; // ignore for now
                }

                if (
                    $rootScope.isAdBlockerInstalled &&
                    location.pathname.indexOf("BlockerInstalled") === -1 &&
                    location.hash.indexOf("BlockerInstalled") === -1
                ) {
                    window.location = "/BlockerInstalled";
                } else if (
                    !$rootScope.isBrowserAllowed &&
                    location.pathname.indexOf("BrowserNotSuppported") === -1 &&
                    location.hash.indexOf("BrowserNotSuppported") === -1
                ) {
                    window.location = "/BrowserNotSuppported";
                }

                $.event.special.scrollstop.latency = 400;
            });

            var intercomData = {};

            if (BF_INFO.user.employee == 3) {
                intercomData = {
                    app_id: "vc7jxmzv",
                    user_id: BF_INFO.user.externalId,
                    name: BF_INFO.user.firstName + " " + BF_INFO.user.lastName,
                    email: BF_INFO.user.email,
                    created_at: BF_INFO.user.created,
                    custom_launcher_selector: ".openIntercom"
                };
            } else {
                var owner = BF_INFO.user.currentAccount.customerSuccessManager
                    ? BF_INFO.user.currentAccount.customerSuccessManager
                    : BF_INFO.user.currentAccount.salesRep;
                intercomData = {
                    app_id: "vc7jxmzv",
                    user_id: BF_INFO.user.externalId,
                    name: BF_INFO.user.firstName + " " + BF_INFO.user.lastName,
                    email: BF_INFO.user.email,
                    created_at: BF_INFO.user.created,
                    job_title: BF_INFO.user.category,
                    company: {
                        id: BF_INFO.user.currentAccount.externalId,
                        name: BF_INFO.user.currentAccount.name,
                        industry: BF_INFO.user.currentAccount.industry,
                        slug: BF_INFO.user.currentAccount.slug,
                        owner: owner,
                        plan: BF_INFO.user.currentAccount.plan.name,
                        package: BF_INFO.user.currentAccount.package,
                        studio: "On",
                        banner_builder: "Off",
                        remote_created_at: BF_INFO.user.currentAccount.created
                    },
                    custom_launcher_selector: ".openIntercom"
                };
            }

            $rootScope.$on(
                "$stateChangeSuccess",
                function (event, toState, toParams, fromState, fromParams) {
                    $timeout(function () {
                        //window.Intercom("update");
                        //Intercom("trackEvent", "Viewed Page", { page: window.location.href });
                    });
                }
            );
        }
    ])
    .factory("auth0Interceptor", function ($q) {
        return {
            request: async function (config) {
                const token = await window.getAuthToken();
                config.headers["Authorization"] = "Bearer " + token;
                return config;
            },

            requestError: function (rejection) {
                console.log("Request Error:", rejection);
                return $q.reject(rejection);
            },

            responseError: function (rejection) {
                console.log("Response Error:", rejection);
                if (rejection.status === 401) {
                    // retry
                }
                return $q.reject(rejection);
            }
        };
    })
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push("auth0Interceptor");
    });
